export enum ItemState {
  UNKNOWN = 1,
  NEW = 2,
  USED = 3,
  REPAIRED = 4
}
